/**
 * Translate SETI array from requestLocals into client-friendly object format.
 * @param SETI
 * @returns {*|{}}
 */

const SETI = {}

function initializeSETI(setiObj = {}) {
  if (!Object.keys(SETI).length) {
    Object.assign(SETI, setiObj)
    Object.freeze(SETI)
  }
}

export { SETI, initializeSETI }
